import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IRiskIssueAlarmItem, IRiskIssueAlarmParams } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 风控管理 - 风控报警分页
 */
export async function queryIssueAlarmPage(params: IRiskIssueAlarmParams) {
  let data = [] as IRiskIssueAlarmItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IRiskIssueAlarmItem[]; total: number }>(`${hostUrl}/risk/distribute-alert/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: resData, total: resTotal } = context || {};

      data = resData || [];
      total = resTotal || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 风控管理 - 风控报警 - 导出
 */

export async function exportIssueAlarm(params: IRiskIssueAlarmParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(`${hostUrl}/risk/distribute-alert/export`, params, { responseType: 'blob' });

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}